import { useForm } from "react-hook-form";
import { IReguaEtapa } from "../../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";

interface IModalCadastrarEtapaProps {
    setShow: (show: boolean) => void;
    idRegua: number;
    updateList: () => void;

    onSubmit: (formData: IFormData) => void;
}

interface IFormData {
    DS_NOME_ETAPA: string;
    NR_ETAPA: number;
    FL_COBRANCA_PREVENTIVA: boolean;
}

export default function ModalCadastrarEtapa(props: IModalCadastrarEtapaProps) {
    const { register, handleSubmit, formState } = useForm<IReguaEtapa>();

    return (
        <>
            <div className="text-center mb-10 mb-lg-20">
                <h2 className="font-weight-bold">Cadastro de Etapa</h2>
            </div>
            <form className="form" onSubmit={handleSubmit(props.onSubmit)}>
                <div className="form-group border-bottom py-3 b-5">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.DS_NOME_ETAPA && "is-invalid"
                        }`}
                        type="text"
                        placeholder="Nome da Etapa"
                        name="DS_NOME_ETAPA"
                        ref={register({
                            required: "Insira o nome da etapa",
                        })}
                        autoComplete="off"
                    />
                    <div className="invalid-feedback">
                        {formState.errors.DS_NOME_ETAPA
                            ? formState.errors.DS_NOME_ETAPA.message
                            : ""}
                    </div>
                </div>
                <div className="form-group border-bottom py-3 b-5">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.NR_ETAPA && "is-invalid"
                        }`}
                        type="number"
                        placeholder="Número da etapa"
                        name="NR_ETAPA"
                        ref={register({
                            required: "Insira o número da etapa",
                        })}
                        autoComplete="off"
                    />
                    <div className="invalid-feedback">
                        {formState.errors.NR_ETAPA
                            ? formState.errors.NR_ETAPA.message
                            : ""}
                    </div>
                </div>
                <div className="form-row mb-5">
                    <div className="col-12 d-flex flex-column align-itens-center justify-content-center">
                        <div className="text-center font-weight-bold">
                            Cobrança Preventiva:
                        </div>
                        <span
                            className="switch switch-outline switch-sm switch-icon switch-info d-flex justify-content-center"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="FL_COBRANCA_PREVENTIVA_STATUS"
                                    name="FL_COBRANCA_PREVENTIVA"
                                    defaultChecked={false}
                                    ref={register()}
                                    type="checkbox"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
                <div className="d-flex flex-wrap justify-content-center align-items-center">
                    <button
                        type="submit"
                        className="btn btn-capys font-weight-bold px-9 py-4 my-2"
                    >
                        Cadastrar
                    </button>
                </div>
            </form>
        </>
    );
}
